import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiRequest } from '../ApiService/Allapi';
import Swal from "sweetalert2";

function Popular() {
    const { slug } = useParams();
    const [pageDetails, setPageDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const stripHtml = (html) => html?.replace(/<[^>]*>?/gm, '') || '';

    const fetchPageDetails = async () => {
        const access_token = localStorage.getItem("token");
        const headers = {
            Authorization: `Bearer ${access_token}`,
        };

        try {
            const res = await apiRequest(`popularpage/${slug}`, "GET", null, headers);
            if (res.status === true) {
                setPageDetails(res.data);
            } else {
                Swal.fire("Error", res.message || "Failed to fetch page details", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while fetching page details!", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPageDetails();
    }, [slug]);

    if (loading) {
        return <div className="container text-center py-5">Loading...</div>;
    }

    if (!pageDetails) {
        return <div className="container text-center py-5">Page not found</div>;
    }

    return (
        <>
        <div className='container-fuild'>
             <img className='w-100' src={pageDetails.banner_image} alt="fds" />
        </div>
          <div className="container py-5">
            <div className="row">
                <div className="col-12 tabs">
                    <h1 className="mb-4">{pageDetails.title}</h1>

                    <p dangerouslySetInnerHTML={{ __html: pageDetails.content }}></p>
                    <div className='text-center'>
                        <img
                            src={pageDetails.image}
                            className="img-fluid w-100 mb-4"
                        
                        />

                    </div>
                    <div className="content" dangerouslySetInnerHTML={{ __html: pageDetails.description }} />
                </div>
            </div>
        </div>
        </>
      
    );
}

export default Popular;